import styled from 'styled-components';

//components
import $ElementResizeListener from 'components/ElementResizeListener';

export const Overlay = styled($ElementResizeListener).attrs({
  position: 'absolute'
})`
  height: 100%;
  left: 0;
  pointer-events: none; // so the underlying image stays clickable
  top: 0;
  width: 100%;
`;

export const KonvaContainer = styled.div`
  position: absolute;
  z-index: 20;
  filter: brightness(100%);
`;
